<script>
import { mapState } from 'pinia';

import { useUserStore } from '../../../store/useUserStore.js';

export default {
  name: 'CpLobbyFlowDialog',
  components: {
    CpMissingInfoForm: require('../lobbying/MissingInfoForm').default,
    CpLobbyFormDialog: require('./LobbyFormDialog').default,
  },
  props: {
    showDialog: { type: Boolean, default: false },
    type: { type: String, default: 'none' },
    customSubject: { type: String, default: null },
    commentToRep: { type: String, default: null },
    newsArticle: { type: Object, default: null },
    politician: { type: Object, default: null },
    modalFeed: { type: Boolean, default: false },
    refProp: { type: Object, default: null },
    callback: { type: Function, default: () => {} },
    shareMessageInComments: { type: Boolean, default: false },
    originalPostType: { type: String, default: null },
    originalPostId: { type: Number, default: null },
  },
  data() {
    return {
      addressUpdated: false,
    };
  },
  computed: {
    ...mapState(useUserStore, ['userProfileData', 'isUserLogin']),
    isAddressCompleted() {
      return this.userProfileData?.address_state && this.userProfileData?.address_zip;
    },
  },
  methods: {
    handleDialog() {
      this.$emit('close');
      this.addressUpdated = false;
    },
    handleAddressUpdated() {
      this.addressUpdated = true;
    },
  },
  watch: {
    showDialog(newVal) {
      if (!newVal) {
        this.addressUpdated = false;
      }
    },
  },
};
</script>

<template>
  <div v-if="showDialog">
    <CpMissingInfoForm 
      v-if="!isAddressCompleted && !addressUpdated" 
      :handleDialog="handleDialog"
      @address-updated="handleAddressUpdated"
    />
    
    <CpLobbyFormDialog
      v-else
      :showDialog="showDialog"
      :type="type"
      :customSubject="customSubject"
      :commentToRep="commentToRep"
      :newsArticle="newsArticle"
      :politician="politician"
      :modalFeed="modalFeed"
      :refProp="refProp"
      :callback="callback"
      :shareMessageInComments="shareMessageInComments"
      :originalPostType="originalPostType"
      :originalPostId="originalPostId"
      @close="handleDialog"
    />
  </div>
</template>
